<template>
  <div class="nj-grid">
    <nj-question-dialog
      ref="removeQuestionDialog"
      title="Excluir Usuário"
      text="Deseja realmente excluir usuário?"
    />
    <div class="header">
      <div class="title">
        <v-icon>mdi-account-outline</v-icon>
        {{ $route.meta.title || $route.name }}
      </div>
      <v-btn
        icon
        title="Retornar"
        class="align-self-baseline"
        :to="{ name: 'Users' }"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </div>
    <div class="ng-grid-body">
      <UserForm ref="form" :disabled="true">
        <div class="form-actions">
          <v-btn
            elevation="0"
            color="primary"
            :to="{ name: 'UserEdit', params: { id: this.$route.params.id } }"
          >
            <v-icon>mdi-clipboard-edit-outline</v-icon>
            Editar
          </v-btn>
        </div>
      </UserForm>
    </div>
  </div>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
import UserForm from './form'

export default {
  name: 'UserShow',
  components: { UserForm },

  methods: {
    remove() {
      if (!this.$hasPermission('naja_app_users_destroy')) {
        alert('Acesso negado')
        return
      }
      this.$refs.removeQuestionDialog.open({
        onConfirm: () => {
          this.$refs.removeQuestionDialog.toggleLoading()
          Api.userOrgaizations
            .destroy(this.$route.params.id)
            .then(async () => {
              this.$router.push({ name: 'Users', query: { refresh: true } })
            })
            .catch(error => {
              if (error.response) {
                // this.$toast.show('Erro ao remover usuário', 'error');
                // this._setErrors(error.response.data.errors);
              } else {
                throw error
              }
            })
        },
      })
    },
  },
}
</script>
